const ai = {
  header: {
    title: "محرك تنسيق المحتوى بالذكاء الاصطناعي",
    description: "اضبط نموذج اللغة المستخدم لإعادة صياغة المنشورات وترجمتها واستخراج الوسوم منها.",
  },
  providers: {
    label: "اختر مزود الذكاء الاصطناعي",
    geminiDescription: "مجموعة سريعة وعالية القدرة من نماذج Google AI.",
    openrouterDescription: "الوصول إلى نماذج لغوية مفتوحة وتجارية من خلال نقطة وصول موحدة.",
    personalCredential: "مفتاح API الخاص بك",
    enabled: "المفتاح الشخصي جاهز",
    missingSecret: "أضف مفتاح API",
    select: "اختيار {{provider}}",
  },
  credentials: {
    title: "بيانات اعتماد API الشخصية",
    description: "مفتاح {{provider}} هذا خاص بحسابك فقط ويُستخدم فقط لطلبات الذكاء الاصطناعي الخاصة بك.",
    label: "مفتاح API لـ {{provider}}",
    placeholder: "ألصق مفتاح API الخاص بـ {{provider}}",
    configured: "مُعدّ",
    maskedNote: "المفتاح المحفوظ مخفي ولا تتم إعادته إلى المتصفح مطلقًا.",
    save: "حفظ المفتاح الشخصي",
    saving: "جارٍ الحفظ…",
    saved: "تم حفظ مفتاح {{provider}} بأمان.",
    replace: "استبدال المفتاح",
    remove: "إزالة المفتاح",
    removing: "جارٍ الإزالة…",
    removeConfirm: "هل تريد إزالة مفتاح API المحفوظ لـ {{provider}}؟ ستتوقف طلبات الذكاء الاصطناعي عبر هذا المزود حتى تضيف مفتاحًا جديدًا.",
    removeError: "تعذر إزالة مفتاح API الخاص بك.",
    cancel: "إلغاء",
    test: "اختبار المفتاح",
    testing: "جارٍ الاختبار…",
    testSuccess: "نجح الاتصال. لم يتم حفظ المفتاح بعد.",
    testError: "فشل اختبار مفتاح API.",
    security: "يُرسل المفتاح إلى الخادم فقط، ويُخزن في Supabase Vault، ولا تتم إعادته إلى المتصفح.",
    saveError: "تعذر حفظ مفتاح API الخاص بك.",
  },
  models: {
    label: "اختر نموذج الذكاء الاصطناعي",
    custom: "نموذج مخصص…",
    customInputLabel: "معرّف النموذج المخصص",
    customPlaceholder: "مثال: meta-llama/llama-3.1-405b-instruct",
    apply: "تطبيق",
    current: "نموذج الذكاء الاصطناعي النشط حاليًا:",
    select: "اختيار النموذج {{model}}",
  },
  playground: {
    title: "ساحة اختبار الذكاء الاصطناعي",
    description: "اختبر مزود الذكاء الاصطناعي النشط والنموذج المحدد. يُرسل النص عبر مسار التنسيق المعتاد على الخادم باستخدام سياق إعادة صياغة إبداعي وقابل للانتشار.",
    credentialRequired: "أضف مفتاح API الشخصي لـ {{provider}} قبل تشغيل الاختبار.",
    inputLabel: "نص عينة للاختبار",
    placeholder: "ألصق نصًا للاختبار هنا…",
    sample: "يساعد جمع منشورات قنوات تيليجرام في إعداد نشرات إخبارية متخصصة.",
    output: "الناتج المنسق",
    error: "خطأ في التنسيق",
    testing: "جارٍ اختبار اتصال الذكاء الاصطناعي…",
    run: "تشغيل اختبار الذكاء الاصطناعي",
  },
  errors: {
    generationFallback: "تعذر على الذكاء الاصطناعي إنشاء استجابة اختبار.",
    connectionFallback: "فشل الاتصال. تحقق من مفتاح API وإعدادات المزود.",
  },
} as const;

export default ai;
